<style lang="less" scoped>
.QuestionGr{display: flex;flex-direction: column;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr {width: 100%;height: 50px;}
.left{width: 200px;}
.f_red {color: red;margin-right: 5px;}
.el-form-item {margin-bottom: 0;}
ul{list-style: none;margin-left: -38px;}
li{display: flex; border: 1px solid #dfdcdc;margin: 10px auto;height: 200px;
.left{width: 210px;border: 1px solid #dfdcdc;}
img{width:100px;height: 120px;margin-top: 20px;}
.right{position: relative;padding: 10px;flex-grow: 1;text-align: left;}
.addtime{position: absolute;left: 10px;bottom: 10px;}}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="QuestionGr" id="QuestionGr">
    <el-form ref="form" :model="form">
      <table>
        <tr>
          <td class="left"><span class="f_red">*</span>咨询内容</td>
          <td class="right">
            <el-form-item>
              <el-input type="textarea" disabled v-model="form.question" :rows="5" style="font-size: 16px"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="left"><span class="f_red">*</span>相关图片</td>
          <td class="right">
            <el-upload
              :action="url"
              :limit="1"
              disabled
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width="100%" />
            </el-dialog>
          </td>
        </tr>
      </table>
    </el-form>
    <ul>
      <li v-for="(item, index) in replyList" :key="index">
        <div class="left">
          <img src="static/images/官网首页/头像.png" />
          <p class="replier">{{ item.replier }}</p>
        </div>
        <div class="right">
          <p class="reply" style="text-indent: 2em;">{{ item.reply }}</p>
          <p class="addtime">回复时间：{{ item.addtime * 1000 | formatTime() }}</p>
        </div>
      </li>
      <li style="margin-top: 50px;">
        <div class="left">
          <img src="static/images/官网首页/头像.png" />
          <p class="replier">{{ msg }}</p>
        </div>
        <div class="right">
          <el-input type="textarea" v-model="reply" :rows="7" placeholder="请输入回复内容" style="font-size: 16px;"></el-input>
        </div>
      </li>
    </ul>
    <div>
      <el-button type="success" style="width: 100px; margin: 20px auto" @click="replyfn()">确认回复</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 专家用户--咨询回复页面
 */
import filters from '../../../method/filter'
export default {
  mixins: [filters],
  props: ['rowid'],
  components: {},
  data()
  {
    return {
      form: {
        type: 1,
        question: ''
      },
      // 上传地址
      url: '',
      // 图片弹框
      dialogVisible: false,
      // 图片预览路径
      dialogImageUrl: '',
      // 回复内容
      reply: '',
      // 图片列表
      fileList: [{url: ''}],
      // 回复列表
      replyList: [],
      // 专家名称
      msg: '',
      hideUploadEdit: false
    }
  },
  created()
  {
    this.getList()
    this.getlocalStorage()
  },
  methods: {
    // 上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    // 获取数据
    getList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 63, _exp: 'id=?', types: 'i', vals: this.rowid, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.form.question = ret[0].content
        this.form.type = ret[0].type
        this.fileList[0].url = ret[0].thumb ? ret[0].thumb : 'static/images/moren.jpg'
      })
      let paras1 = {cmd: 'queryUnion', _major: 11, _minor: 64, tables: 'A;B:11,63', cols: 'A:*;B:content,thumb', _exp: `A.glid = ${this.rowid} and` + ' A.glid=B.id', orderby: 'addtime DESC'}
      window.post.getPost(paras1).then((ret) =>
      {
        this.replyList = ret
      })
    },
    // 回复
    replyfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 64,
        retAtt: 1,
        glid: this.rowid,
        reply: this.reply,
        addtime: Date.parse(new Date()) / 1000,
        replier: this.msg
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          let paras = {cmd: 'updateAtt', _major: 11, _minor: 63, id: this.rowid, iscomments: 1}
          window.post.getPost(paras).then((ret) =>
          {
            this.$message({message: '回复成功', type: 'success', customClass: 'mzindex'})
            this.getList()
            this.$emit('cancle')
          })
        }
      })
      this.reply = ''
    },
    getlocalStorage()
    {
      if (this.$route.path === '/ZxServer' || this.$route.path === '/FlServer')
        this.msg = JSON.parse(localStorage.getItem('userMsg')).username
      else
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
            this.msg = ret[0].passport
        })
      }
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/zxxx/ZX/ConsultingReply.vue